import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../api/axiosInstance';

const BASE_URL = '/api/employees/';

// Async thunks
export const fetchDailySubstitutes = createAsyncThunk(
  'substitute/fetchDailySubstitutes',
  async (params = {}, thunkAPI) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.day_of_week) queryParams.append('day_of_week', params.day_of_week);
      if (params.date) queryParams.append('date', params.date);
      
      const url = `${BASE_URL}daily-substitutes/${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'فشل جلب المناوبين');
    }
  }
);

export const createDailySubstitute = createAsyncThunk(
  'substitute/createDailySubstitute',
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(`${BASE_URL}daily-substitutes/`, data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'فشل إنشاء المناوبين');
    }
  }
);

export const updateDailySubstitute = createAsyncThunk(
  'substitute/updateDailySubstitute',
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await axios.put(`${BASE_URL}daily-substitutes/${id}/`, data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'فشل تحديث المناوبين');
    }
  }
);

export const deleteDailySubstitute = createAsyncThunk(
  'substitute/deleteDailySubstitute',
  async (id, thunkAPI) => {
    try {
      await axios.delete(`${BASE_URL}daily-substitutes/${id}/`);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'فشل حذف المناوبين');
    }
  }
);

const initialState = {
  substitutes: [],
  loading: {
    fetch: false,
    create: false,
    update: false,
    delete: false,
  },
  error: null,
};

const substituteSlice = createSlice({
  name: 'substitute',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch
    builder
      .addCase(fetchDailySubstitutes.pending, (state) => {
        state.loading.fetch = true;
        state.error = null;
      })
      .addCase(fetchDailySubstitutes.fulfilled, (state, action) => {
        state.loading.fetch = false;
        state.substitutes = action.payload;
      })
      .addCase(fetchDailySubstitutes.rejected, (state, action) => {
        state.loading.fetch = false;
        state.error = action.payload;
      });

    // Create
    builder
      .addCase(createDailySubstitute.pending, (state) => {
        state.loading.create = true;
        state.error = null;
      })
      .addCase(createDailySubstitute.fulfilled, (state, action) => {
        state.loading.create = false;
        state.substitutes.push(action.payload);
      })
      .addCase(createDailySubstitute.rejected, (state, action) => {
        state.loading.create = false;
        state.error = action.payload;
      });

    // Update
    builder
      .addCase(updateDailySubstitute.pending, (state) => {
        state.loading.update = true;
        state.error = null;
      })
      .addCase(updateDailySubstitute.fulfilled, (state, action) => {
        state.loading.update = false;
        const index = state.substitutes.findIndex(s => s.id === action.payload.id);
        if (index !== -1) {
          state.substitutes[index] = action.payload;
        }
      })
      .addCase(updateDailySubstitute.rejected, (state, action) => {
        state.loading.update = false;
        state.error = action.payload;
      });

    // Delete
    builder
      .addCase(deleteDailySubstitute.pending, (state) => {
        state.loading.delete = true;
        state.error = null;
      })
      .addCase(deleteDailySubstitute.fulfilled, (state, action) => {
        state.loading.delete = false;
        state.substitutes = state.substitutes.filter(s => s.id !== action.payload);
      })
      .addCase(deleteDailySubstitute.rejected, (state, action) => {
        state.loading.delete = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = substituteSlice.actions;
export default substituteSlice.reducer;
